<template>
	<div class="history-message-box">
		<ul v-show="!this.isViewContext">
			<li v-for="(message, index) in messageSortByTimestamp" v-bind:key="message.id" @mouseover="showViewContext(index)" @mouseout="hideViewContext()">
				<div class="item-list" v-if="!message.is_delete">
					<div class="avatar-wrap">
						<ChatAvatar class="avatar" :avatar="message.sender_avatar" borderRadius="3px" size="30" />
					</div>
					<div class="content">
						<div class="body-wrap">
							<div class="name">{{ message.sender_note ? message.sender_note : message.sender_name }}</div>
							<div class="message" @contextmenu.prevent.stop="handleContextmenu($event, message)">
								<!-- 文本消息 -->
								<ChatMessageText v-if="message.type === MESSAGE_TYPE.Text" :content="message.text" />
								<!-- 语音消息 -->
								<ChatMessageVoice
									v-else-if="message.type === MESSAGE_TYPE.Voice"
									:id="message.id"
									:attachmentUrl="message.attachment_url"
									:length="message.length"
									:isSelf="message.is_sender"
									class="history-voice"
								/>
								<!-- 图片消息 -->
								<ChatMessageImage v-else-if="message.type === MESSAGE_TYPE.Image" :message="message" @handle-image-view="handleImageView" />
								<!-- 订单信息 -->
								<div class="order" v-else-if="message.type === MESSAGE_TYPE.Order">
									<ChatMessageOrder :message="message" />
								</div>
								<!-- 自动发送的订单信息 -->
								<div class="order" v-else-if="message.type === MESSAGE_TYPE.MerchantOrder">
									<ChatMessageMerchantOrder :message="message" />
								</div>

								<!-- 支票上传提醒 -->
								<div class="check" v-else-if="message.type === MESSAGE_TYPE.Check">
									<ChatMessageCheck :message="message" />
								</div>

								<!-- redirect消息提醒 -->
								<div class="redirect" v-else-if="message.type === MESSAGE_TYPE.Redirect">
									<ChatMessageRedirect :message="message" />
								</div>

								<!--视频消息 -->
								<ChatMessageVideo
									v-else-if="message.type === MESSAGE_TYPE.Video"
									:message="message"
									:show-filename="true"
									:auto-thumbnail="true"
									@handle-video-viewer="handleVideoViewer"
								/>
								<!-- 版本过低文本提醒 -->
								<ChatMessageUnderversion v-else />
							</div>
						</div>
						<div class="datetime">
							<p>{{ message.timestamp | messageDateFormat }}</p>
							<a href="javascript:;" v-show="viewContextActive === index && searchHistoryKeyword" @click="viewContext(message)">{{
								$t("chatHistoryMessage.viewContext")
							}}</a>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<ul v-if="this.isViewContext" class="view-context-box" ref="viewContext" @scroll="handleViewContextScroll" v-loading="loading">
			<li
				v-for="(message, index) in viewContextMessageSortByTimestamp"
				v-bind:key="message.id"
				@mouseover="showViewContext(index)"
				@mouseout="hideViewContext()"
			>
				<div class="item-list" v-if="!message.is_delete">
					<div class="avatar-wrap">
						<ChatAvatar class="avatar" :avatar="message.sender_avatar" borderRadius="3px" size="30" />
					</div>
					<div class="content">
						<div class="body-wrap">
							<div class="name">{{ message.sender_name }}</div>
							<div class="message" @contextmenu.prevent.stop="handleContextmenu($event, message)">
								<!-- 文本消息 -->
								<ChatMessageText v-if="message.type === 0" :content="message.text" />
								<!-- 语音消息 -->
								<ChatMessageVoice
									v-else-if="message.type === 1"
									:id="message.id"
									:attachmentUrl="message.attachment_url"
									:length="message.length"
									:isSelf="message.is_sender"
									class="history-voice"
								/>
								<!-- 图片消息 -->
								<ChatMessageImage v-else-if="message.type === 2" :message="message" @handle-image-view="handleImageView" />
								<!-- 订单信息 -->
								<div class="order" v-else-if="message.type === 3">
									<ChatMessageOrder :message="message" />
								</div>

								<!-- 支票上传提醒 -->
								<div class="check" v-else-if="message.type === 4">
									<ChatMessageCheck :message="message" />
								</div>

								<!-- redirect消息提醒 -->
								<div class="redirect" v-else-if="message.type === 5">
									<ChatMessageRedirect :message="message" />
								</div>

								<!-- 视频消息 -->
								<ChatMessageVideo v-else-if="message.type === 8" :message="message" @handle-video-viewer="handleVideoViewer" />

								<!-- 版本过低文本提醒 -->
								<ChatMessageNonsupport v-else />
							</div>
						</div>
						<div class="datetime">
							<p>{{ message.timestamp | messageDateFormat }}</p>
						</div>
					</div>
				</div>
			</li>
		</ul>

		<vue-simple-context-menu :elementId="'history-message-menu'" :options="options" :ref="'contextMenu'" @option-clicked="handleOptionClicked" />
	</div>
</template>

<script>
import ChatAvatar from "./chat-avatar.vue";
import ChatMessageText from "./chat-message-text.vue";
import ChatMessageImage from "./chat-message-image.vue";
import ChatMessageVoice from "./chat-message-voice.vue";
import ChatMessageOrder from "./chat-message-order.vue";
import ChatMessageMerchantOrder from "./chat-message-merchant-order.vue";
import ChatMessageCheck from "./chat-message-check.vue";
import ChatMessageNonsupport from "./chat-message-nonsupport.vue";
import ChatMessageRedirect from "./chat-message-redirect.vue";
import ChatMessageVideo from "./chat-message-video.vue";
import { getUserCustomers, getNextMessages, getPreviousMessages } from "@/services/api-v2/api-v2";
import _ from "lodash";
import { MESSAGE_TYPE } from "../chat";

export default {
	name: "ChatHistoryMessages",
	components: {
		ChatAvatar,
		ChatMessageText,
		ChatMessageImage,
		ChatMessageVoice,
		ChatMessageOrder,
		ChatMessageCheck,
		ChatMessageRedirect,
		ChatMessageNonsupport,
		ChatMessageVideo,
		ChatMessageMerchantOrder,
	},
	props: {
		messages: {
			type: Array,
			required: false,
			default: null,
		},
		searchHistoryKeyword: {
			type: String,
			required: false,
			default: "",
		},
		conversation: {
			type: Object,
			required: false,
			default: null,
		},

		isViewContext: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			MESSAGE_TYPE,
			options: [
				{
					name: this.$t("chatHistoryMessage.copy"),
					slug: "copy",
				},
				{
					name: this.$t("chatHistoryMessage.save"),
					slug: "save",
				},
			],

			loading: false,

			viewContextActive: -1,

			viewContextMessage: [],
		};
	},

	methods: {
		// 图片查看点击事件
		handleImageView(message) {
			this.$emit("handle-image-view", message);
		},
		// 媒体查看点击事件
		handleVideoViewer(message) {
			this.$emit("handle-video-viewer", message);
		},
		// 聊天对话右键
		handleContextmenu(event, message) {
			Object.defineProperty(event, "pageX", {
				value: event.pageX - 480,
				writable: true,
			});

			Object.defineProperty(event, "pageY", {
				value: event.pageY - 130,
				writable: true,
			});

			this.$refs.contextMenu.showMenu(event, message);
		},

		// 消息右键功能
		handleOptionClicked(event) {
			switch (event.option.slug) {
				case "copy":
					this.copyMessage(event.item);
					break;
				case "save":
					this.saveMessage(event.item);
					break;
			}
		},

		// 消息复制
		copyMessage(message) {
			if (message.type === 0) {
				this.$copyText(message.text).then(
					() => this.$message({ message: this.$t("chatHistoryMessage.copiedToClipboard"), type: "success" }),
					() => this.$message({ message: this.$t("chatHistoryMessage.copyFailed"), type: "warning" })
				);
			} else {
				this.$message({ message: this.$t("chatHistoryMessage.errorTextMessage"), type: "warning" });
			}
		},

		// 保存语音
		async saveMessage(message) {
			if (message.type === 1) {
				const { data } = await getUserCustomers(message.sender_id);
				const response = await fetch(message.attachment_url);
				const blob = await response.blob();
				const file = new File([blob], "new_voice_name.aac", { type: blob.type });
				const url = URL.createObjectURL(file);
				const link = document.createElement("a");
				if (data.id > 230) {
					const dataId = data.id.slice(0, 230);
					link.download = `${message.timestamp}-${dataId}.aac`;
				} else {
					link.download = `${message.timestamp}-${data.id}.aac`;
				}
				link.href = url;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} else {
				this.$message({ message: this.$t("chatHistoryMessage.errorMessage"), type: "warning" });
			}
		},

		showViewContext(index) {
			this.viewContextActive = index;
		},

		hideViewContext() {
			this.viewContextActive = -1;
		},

		clearCiewContextMessage() {
			this.viewContextMessage = [];
		},

		async handleViewContextScroll(e) {
			try {
				if (e.target.scrollTop === 0) {
					this.loading = true;
					if (this.viewContextMessageSortByTimestamp[0].receive_id) {
						const { data } = await getPreviousMessages(this.viewContextMessageSortByTimestamp[0].id, this.conversation.object_id, null);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					} else {
						const { data } = await getPreviousMessages(this.viewContextMessageSortByTimestamp[0].id, null, this.conversation.object_id);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					}
				} else if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
					let index = this.viewContextMessageSortByTimestamp.length;

					if (this.viewContextMessageSortByTimestamp[index - 1].receive_id) {
						const { data } = await getNextMessages(this.viewContextMessageSortByTimestamp[index - 1].id, this.conversation.object_id, null);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					} else {
						const { data } = await getNextMessages(this.viewContextMessageSortByTimestamp[index - 1].id, null, this.conversation.object_id);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					}
				}
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		async viewContext(message) {
			this.$emit("handle-view-context");
			try {
				this.loading = true;
				if (message.receive_id) {
					const { data } = await getNextMessages(message.id, this.conversation.object_id, null);
					if (data.length) {
						this.viewContextMessage = this.viewContextMessage.concat(data);
					} else {
						const { data } = await getPreviousMessages(message.id, this.conversation.object_id, null);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					}
				} else {
					const { data } = await getNextMessages(message.id, null, this.conversation.object_id);
					if (data.length) {
						this.viewContextMessage = this.viewContextMessage.concat(data);
					} else {
						const { data } = await getPreviousMessages(message.id, null, this.conversation.object_id);
						this.viewContextMessage = this.viewContextMessage.concat(data);
					}
				}
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
				this.$nextTick(() => {
					const viewContext = this.$refs.viewContext;
					viewContext.scrollTop = 50;
				});
			}
		},
	},
	computed: {
		//按时间排序并去除已撤回的消息
		messageSortByTimestamp() {
			return _.filter(_.sortBy(this.messages, ["timestamp"]), (_item) => {
				if (!_item.is_delete) {
					return _item;
				}
			});
		},

		viewContextMessageSortByTimestamp() {
			return _.filter(_.sortBy(this.viewContextMessage, ["timestamp"]), (_item) => {
				if (!_item.is_delete) {
					return _item;
				}
			});
		},
	},
	directives: {
		scroll: {
			inserted: function (el, binding) {
				el.addEventListener("scroll", binding.value);
			},
			unbind: function (el, binding) {
				el.removeEventListener("scroll", binding.value);
			},
		},
	},
};
</script>

<style lang="less" scoped>
ul {
	list-style: none;
	padding-left: 0px;
	margin-top: 0;
	> li {
		margin-bottom: 10px;
		.avatar-wrap {
			display: flex;
			align-items: flex-start;
			margin-right: 10px;
			.avatar {
				display: block;
			}
		}
	}
	> li:last-child {
		.content {
			border: 0;
		}
	}
	.item-wrap {
		display: flex;
		flex: 1;
		flex-direction: column;
	}
	.item-list {
		display: flex;
		justify-content: space-between;
		padding-right: 15px;
		.content {
			display: flex;
			flex: 1;
			flex-direction: row;
			border-bottom: 1px solid #e7e7e7;
			padding-bottom: 10px;
			.body-wrap {
				display: flex;
				flex: 1;
				flex-direction: column;
				.name {
					margin-bottom: 8px;
					color: #ababab;
				}
				.history-voice {
					background-color: #dfdfdf;
					padding: 5px;
					border-radius: 3px;
				}
				.order {
					padding: 10px;
					max-width: 200px;
					font-size: 12px;
					background-color: #dfdfdf;
					border-radius: 4px;
				}
				.check {
					padding: 10px;
					max-width: 200px;
					font-size: 12px;
					background-color: #dfdfdf;
					border-radius: 4px;
				}
				.redirect {
					padding: 10px;
					max-width: 200px;
					font-size: 12px;
					background-color: #dfdfdf;
					border-radius: 4px;
				}
			}
		}
	}
}

.datetime {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	p {
		margin: 0;
	}
	a {
		text-decoration: none;
		margin-top: 8px;
		color: #6081c7;
	}
	a:hover {
		color: #7c8cae;
	}
}
.view-context-box {
	height: 500px;
	overflow: auto;
}
</style>
